export default __webpack_public_path__ + "static/B0040-0413a2064cbeaa8ef0b17638ec504411.png";